<template>
	<section class="row">
		<div class="left_window column">

			<!-- Шапка -->
			<sm-phone-header></sm-phone-header>
			<h1 class="title_page">Кабинет врача</h1>

			<!-- Блок уведомлений -->
			<user-notifications :user-type="'worker'"></user-notifications>

			<!-- Начать мгновенный прием прием -->
			<div class="top_btns_wrap">
				<div class="begin_reception add_value hover-bg" @click="createMomentalEvent">
					Начать прием без предварительной записи
				</div>
			</div>

			<!--Ближайшие визиты-->
			<coming-visit></coming-visit>

			<!-- События -->
			<user-events :user-type="'worker'"></user-events>

			<sm-phone-footer></sm-phone-footer>
		</div>
		<div class="right_window column">
			<large-scheduler :isDoctor="true"></large-scheduler>
		</div>

	</section>
</template>

<script>
	import moment from 'moment'

	export default {
		name: 'Doctor',
		computed: {
			doctorId() {
				return this.$route.query.doctor
			}
		},
		mounted() {
			this.$parent.dashClases = ['doctor-cabinet']

			this.$event.send('updateEvents', this.doctorId)
		},
		data() {
			return {
				visits: []
			}
		},
		methods: {
			createMomentalEvent() {
				this.$event.send('openMomentalModal', {
					begin: moment().format('X')
				}, {_id: this.doctorId})
			}
		},
		watch: {
			doctorId(val) {
				this.$event.send('updateEvents', val)
			}
		}
	}
</script>




// WEBPACK FOOTER //
// DoctorPage.vue?055800de